import { Helpers } from './helpers';
export const isNode = process.env.ISNODE;
/**
\
 * Based on the hostname determine whether api client should use a relative link
 * @param {*} hostname 
 */
export const useRelativeLink = () => {
    let currHost = isNode ? 'server' : document.location.hostname;
    return currHost !== 'server' && currHost !== 'localhost' && currHost.indexOf('hpstoreapp') < 0;
};

/***
 * Interceptor that adds context related query parameter from ETR to all api calls
 * @param {*} httpConfig - axios http config object
 */
export const contextParameterInterceptor = httpConfig => {
    //TODO: find a better way to get the pStoreID in to these queries potentially
    if (typeof document !== 'undefined') {
        const query = Helpers.getSearch(document.location.search);
        httpConfig.params = httpConfig.params || {};
        //some API like HPService call it with pstoreId instead (fml)
        if (query.pStoreID && !httpConfig.params.pstoreId) {
            httpConfig.params.pStoreID = query.pStoreID;
        }
        if (query.previewToken) {
            httpConfig.params.previewToken = query.previewToken;
        }
    }
    return httpConfig;
};
